const state = () => {
  return {
    user: localStorage.getItem('user') || '',
    exerciseView: '',
    position: 'home',
    isApp: false
  }
}

const getters = {
  isLoggedIn: state => !!state.user
}
const actions = {
  save_exerciseView({commit}, exerciseView) {
    commit('exerciseView', exerciseView)
  },
  save_position({commit}, position) {
    commit('position', position)
  },
  save_isApp({commit}, isApp) {
    commit('isApp', isApp)
  }
}
const mutations = {
  exerciseView(state, exerciseView){
    state.exerciseView = exerciseView
  },
  position(state, position){
    state.position = position
  },
  isApp(state, isApp){
    state.isApp = isApp
  }
}
export const session = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
